// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__CvFCM","qualcommimg":"SponsorsSection_qualcommimg__nq65T"};